<template>
  <div>

    <TitlePage :title="$t('sportsCenter')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

<!--      <v-col cols="12" md="6">-->
<!--        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>-->
<!--      </v-col>-->

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile class="px-4 py-3">
      <v-row class="align-center">
        <v-col cols="12" md="4">
          <v-text-field
              v-model="filter.q"
              :label="$t('filterResults')"
              prepend-inner-icon="mdi-magnify"
              clearable dense outlined hide-details
              placeholder="Cerca per nome"
          />
        </v-col>

        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item._id="{ item }">
          <router-link target="_blank" rel="noopener" :to="`/centers/edit/${item._id}`">
            {{ item._id }}
          </router-link>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="closures(item._id)" :title="$t('closures')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-lock-clock</v-icon>{{ $t('closures') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="fixedBookings(item._id)" :title="$t('fixed_bookings')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-circle-edit-outline</v-icon>{{ $t('fixed_bookings') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="field(item._id)" :title="$t('fields')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-soccer-field</v-icon>{{ $t('fields') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="media(item._id)" :title="$t('media')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-camera-plus</v-icon>{{ $t('media') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="info(item._id)" :title="$t('info')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-folder-information-outline</v-icon>{{ $t('info') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="config(item._id)" :title="$t('configurations')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-label-percent</v-icon>{{ $t('configurations') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>{{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.active" inset @change="updateSingleStatus(item)" dense hide-details class="mt-0"></v-switch>
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleString() }}
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";

const exportService = require('@/services/export')

export default {
  name: 'Centers',
  components: {ItemActions, ModalDelete, TitlePage, CenterAutocomplete},
  data() {
    return {
      pathCreate: '/centers/create/',
      pathConfig: '/centers/configurations/',
      pathEdit: '/centers/edit/',
      pathMedia: '/centers/media/',
      pathInfo: '/centers/info/',
      pathFixedBookings: '/fixed-bookings/edit/',
      pathClosures: '/closures/',
      pathFields: '/fields',
      search: '',
      selected: [],
      headers: [
        { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('name'), align: 'start', value: 'name'},
        { text: this.$t('addressComplete'), align: 'start', value: 'address_complete'},
        { text: this.$t('status'), value: 'status', sortable: false},
        { text: this.$t('creation_date'), value: 'created_at'},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {
        q: null,
        _id: null
      },
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100]
    };
  },
  async created(){
    if(!this.getUser.super_admin){
      this.$router.push('/')
      return
    }
    this.setLoading(true);
    this.filter = Object.assign({},this.getFilter)
    this.filter._id = (this.$route.query._id) ? this.$route.query._id : null
    this.options_pagination = Object.assign({},this.getOptionsPagination)
    await this.makeSearch()
    this.setLoading(false);
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(true); }, 350);
  },
  watch: {
    'filter.q': function(){ this._debouncedSearch(); }
  },
  computed: {
    ...mapGetters({
      'getFilter':'centers/getFilter',
      'getOptionsPagination':'centers/getOptionsPagination',
      'getUser':'user/getUser',
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'centers/index',
      'updateItem':'centers/update',
      'deleteItem': 'centers/delete',
      'massiveDeleteItem': 'centers/massDelete',
      'setFilter': 'centers/setFilter',
      'setOptionsPagination': 'centers/setOptionsPagination',
    }),

    debounce(fn, wait){
      var t = null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },

    async resetFilter(){
      this.filter = { q: null, _id: null };
      this.options_pagination = { page: 1, limit: 10 };
      await this.makeSearch(true);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },
    async makeSearch() {
      this.setLoading(true);

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },
    media(id){
      this.$router.push(this.pathMedia+id)
    },
    info(id){
      this.$router.push(this.pathInfo+id)
    },
    fixedBookings(id){
      this.$router.push(this.pathFixedBookings+id)
    },
    closures(id){
      this.$router.push(this.pathClosures+id)
    },
    config(id){
      this.$router.push(this.pathConfig+id)
    },
    field(id){
      this.$router.push(this.pathFields+'?center_id='+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems(this.getOptionsPagination);
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems(this.getOptionsPagination);
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {active: item.active}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async getNewPage(){
      await this.setLoading(true);
      await this.makeSearch()
      await this.setLoading(false);
    },
    calculatePagination(count, limit){

      var divide = (count / limit)
      var rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },

    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
